var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('h2',{staticClass:"section__title"},[_vm._v(" Race starts in ")]),_c('countdown',{ref:"timer",attrs:{"deadline":_vm.countdownDeadline}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }